import React, { Component } from 'react';
import { MDBDataTable } from 'mdbreact';

/**
 * Accessible wrapper around MDBDataTable.
 * Adds scope="col" to th elements, labels search/pagination controls,
 * and wraps the table in a labeled region.
 *
 * Usage: <AccessibleDataTable caption="Blog Management" entries={100} data={table} />
 * All props except 'caption' are passed through to MDBDataTable.
 */
export class AccessibleDataTable extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
    }

    componentDidMount() {
        this.enhanceAccessibility();
    }

    componentDidUpdate() {
        this.enhanceAccessibility();
    }

    enhanceAccessibility() {
        if (!this.tableRef.current) return;
        let container = this.tableRef.current;

        // Add scope="col" to all <th> elements in thead
        let thElements = container.querySelectorAll('thead th');
        for (let i = 0; i < thElements.length; i++) {
            thElements[i].setAttribute('scope', 'col');
        }

        // Label the search input if present
        let searchInput = container.querySelector('input[type="text"][class*="form-control"]');
        if (searchInput && !searchInput.getAttribute('aria-label')) {
            searchInput.setAttribute('aria-label', 'Search ' + (this.props.caption || 'table'));
        }

        // Label pagination buttons
        let paginationLinks = container.querySelectorAll('.page-link');
        for (let i = 0; i < paginationLinks.length; i++) {
            let link = paginationLinks[i];
            let text = link.textContent.trim();
            if (text === '<' || text === '\u2039' || text === 'Previous') {
                link.setAttribute('aria-label', 'Previous page');
            } else if (text === '>' || text === '\u203A' || text === 'Next') {
                link.setAttribute('aria-label', 'Next page');
            }
        }

        // Label entries-per-page select if present
        let select = container.querySelector('select');
        if (select && !select.getAttribute('aria-label')) {
            select.setAttribute('aria-label', 'Rows per page');
        }
    }

    render() {
        let { caption, ...mdbProps } = this.props;

        return (
            <div ref={this.tableRef} role="region" aria-label={caption || 'Data table'}>
                <MDBDataTable {...mdbProps} />
            </div>
        );
    }
}
